/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getImplantGroups } from 'app/entities/implant-group/implant-group.reducer';
import { getEntities as getDeviceManufacurers } from 'app/entities/device-manufacurer/device-manufacurer.reducer';
import { getEntities as getCatalogDefinitions } from 'app/entities/catalog-definitions/catalog-definitions.reducer';
import { MRISSafety } from 'app/shared/model/enumerations/mris-safety.model';
import { createEntity, getEntity, reset, updateEntity } from './implant.reducer';

export const ImplantUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const implantGroups = useAppSelector(state => state.implantGroup.entities);
  const deviceManufacurers = useAppSelector(state => state.deviceManufacurer.entities);
  const catalogDefinitions = useAppSelector(state => state.catalogDefinitions.entities);
  const implantEntity = useAppSelector(state => state.implant.entity);
  const loading = useAppSelector(state => state.implant.loading);
  const updating = useAppSelector(state => state.implant.updating);
  const updateSuccess = useAppSelector(state => state.implant.updateSuccess);
  const mRISSafetyValues = Object.keys(MRISSafety);

  const handleClose = () => {
    navigate(`/implant${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getImplantGroups({}));
    dispatch(getDeviceManufacurers({}));
    dispatch(getCatalogDefinitions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }

    const entity = {
      ...implantEntity,
      ...values,
      group: implantGroups.find(it => it.id.toString() === values.group?.toString()),
      manufacturer: deviceManufacurers.find(it => it.id.toString() === values.manufacturer?.toString()),
      catalog: catalogDefinitions.find(it => it.id.toString() === values.catalog?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          mriSafety: 'SAFE',
          ...implantEntity,
          group: implantEntity?.group?.id,
          manufacturer: implantEntity?.manufacturer?.id,
          catalog: implantEntity?.catalog?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.implant.home.createOrEditLabel" data-cy="ImplantCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.implant.home.createOrEditLabel">Create or edit a Implant</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="implant-id"
                  label={translate('tinyMedicRestApp.implant.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.name')}
                id="implant-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 1000, message: translate('entity.validation.maxlength', { max: 1000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.active')}
                id="implant-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.addedBy')}
                id="implant-addedBy"
                name="addedBy"
                data-cy="addedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.timestampentry')}
                id="implant-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.dunsNumber')}
                id="implant-dunsNumber"
                name="dunsNumber"
                data-cy="dunsNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.brandName')}
                id="implant-brandName"
                name="brandName"
                data-cy="brandName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.deviceDescription')}
                id="implant-deviceDescription"
                name="deviceDescription"
                data-cy="deviceDescription"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.biodegradable')}
                id="implant-biodegradable"
                name="biodegradable"
                data-cy="biodegradable"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.radioActive')}
                id="implant-radioActive"
                name="radioActive"
                data-cy="radioActive"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.mriSafety')}
                id="implant-mriSafety"
                name="mriSafety"
                data-cy="mriSafety"
                type="select"
              >
                {mRISSafetyValues.map(mRISSafety => (
                  <option value={mRISSafety} key={mRISSafety}>
                    {translate(`tinyMedicRestApp.MRISSafety.${mRISSafety}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.lastupdated')}
                id="implant-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.unit')}
                id="implant-unit"
                name="unit"
                data-cy="unit"
                type="text"
                validate={{
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.quantity')}
                id="implant-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
                validate={{
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.price')}
                id="implant-price"
                name="price"
                data-cy="price"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.cursor')}
                id="implant-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implant.microSec')}
                id="implant-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="implant-group"
                name="group"
                data-cy="group"
                label={translate('tinyMedicRestApp.implant.group')}
                type="select"
                required
              >
                <option value="" key="0" />
                {implantGroups
                  ? implantGroups.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="implant-manufacturer"
                name="manufacturer"
                data-cy="manufacturer"
                label={translate('tinyMedicRestApp.implant.manufacturer')}
                type="select"
              >
                <option value="" key="0" />
                {deviceManufacurers
                  ? deviceManufacurers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="implant-catalog"
                name="catalog"
                data-cy="catalog"
                label={translate('tinyMedicRestApp.implant.catalog')}
                type="select"
              >
                <option value="" key="0" />
                {catalogDefinitions
                  ? catalogDefinitions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/implant" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ImplantUpdate;
